import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { __export } from "./chunk-QK4PKNB3.mjs"; // src/utils/Chat.ts

var Chat_exports = {};

__export(Chat_exports, {
  getMessagesWithAvatar: function getMessagesWithAvatar() {
    return _getMessagesWithAvatar;
  },
  getSearchChatDoc: function getSearchChatDoc() {
    return _getSearchChatDoc;
  },
  getUserDisplayNameByTargetAudience: function getUserDisplayNameByTargetAudience() {
    return _getUserDisplayNameByTargetAudience;
  }
});

import _ from "lodash";

var _getMessagesWithAvatar = function _getMessagesWithAvatar(_ref) {
  var chatroom = _ref.chatroom,
      messages = _ref.messages;
  return _.map(messages, function (msg) {
    var _msg$user;

    var mediaUrl = msg.mediaUrl,
        mediaType = msg.mediaType,
        coverUrl = msg.coverUrl,
        repliedMessage = msg.repliedMessage;
    var gid = "";

    if (msg !== null && msg !== void 0 && (_msg$user = msg.user) !== null && _msg$user !== void 0 && _msg$user._id) {
      var _msg$user2;

      gid = msg === null || msg === void 0 ? void 0 : (_msg$user2 = msg.user) === null || _msg$user2 === void 0 ? void 0 : _msg$user2._id;
    } else {
      gid = msg.sender;
    }

    var user = getMessagesUser({
      gid: gid,
      chatroom: chatroom
    });
    var newRepliedMessage = repliedMessage;

    if (repliedMessage) {
      var gid2 = repliedMessage.sender,
          user2 = repliedMessage.user;

      if (!user2) {
        newRepliedMessage = _objectSpread(_objectSpread({}, newRepliedMessage), {}, {
          user: getMessagesUser({
            gid: gid2,
            chatroom: chatroom,
            repliedMessage: true
          })
        });
      }
    }

    var image = void 0;

    if (mediaType === "image") {
      image = mediaUrl;
    } else if (mediaType === "video" && coverUrl) {
      image = coverUrl;
    }

    return _objectSpread(_objectSpread({}, msg), {}, {
      image: image,
      user: user,
      mediaUrl: mediaUrl,
      mediaType: mediaType,
      isMedia: !!mediaType,
      repliedMessage: newRepliedMessage
    });
  });
};

var _getSearchChatDoc = function _getSearchChatDoc(_ref2) {
  var chatroom = _ref2.chatroom,
      messages = _ref2.messages;
  return _.map(messages, function (msg) {
    var gid = msg.sender,
        mediaUrl = msg.mediaUrl,
        mediaType = msg.mediaType,
        coverUrl = msg.coverUrl,
        repliedMessage = msg.repliedMessage;
    var user = getMessagesUser({
      gid: gid,
      chatroom: chatroom
    });
    var newRepliedMessage = repliedMessage;

    if (repliedMessage) {
      var gid2 = repliedMessage.sender,
          user2 = repliedMessage.user;

      if (!user2) {
        newRepliedMessage = _objectSpread(_objectSpread({}, newRepliedMessage), {}, {
          user: getMessagesUser({
            gid: gid2,
            chatroom: chatroom,
            repliedMessage: true
          })
        });
      }
    }

    var image = void 0;

    if (mediaType === "image") {
      image = mediaUrl;
    } else if (mediaType === "video" && coverUrl) {
      image = coverUrl;
    }

    return _objectSpread(_objectSpread({}, msg), {}, {
      image: image,
      user: user,
      mediaUrl: mediaUrl,
      mediaType: mediaType,
      isMedia: !!mediaType,
      repliedMessage: newRepliedMessage
    });
  });
};

var getMessagesUser = function getMessagesUser(_ref3) {
  var gid = _ref3.gid,
      chatroom = _ref3.chatroom,
      repliedMessage = _ref3.repliedMessage;
  var _chatroom$members = chatroom.members,
      members = _chatroom$members === void 0 ? [] : _chatroom$members,
      isService = chatroom.isService,
      serviceAvatar = chatroom.avatar_thumbnail_url,
      avatarIcon = chatroom.avatar;
  var member = _.find(members, {
    gid: gid
  }) || {
    nick_name: "",
    name: "",
    id: ""
  };
  var nick_name = member.nick_name,
      name = member.name,
      id = member.id,
      memberAvatar = member.avatar_thumbnail_url,
      type = member.class_name;
  var avatar = isService && !repliedMessage ? serviceAvatar : memberAvatar;
  var user = {
    _id: gid,
    avatar: avatar,
    avatarIcon: avatarIcon,
    name: name,
    nick_name: nick_name,
    id: id,
    type: type,
    isService: isService
  };
  return user;
};

var _getUserDisplayNameByTargetAudience = function _getUserDisplayNameByTargetAudience(user) {
  var targetAudience = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "user";
  var name = user.name,
      nick_name = user.nick_name;
  var displayName = "";

  if (targetAudience === "user") {
    displayName = name;
  } else if (targetAudience === "client") {
    displayName = nick_name;
  } else {
    displayName = name || nick_name;
  }

  return displayName;
};

export { _getMessagesWithAvatar as getMessagesWithAvatar, _getSearchChatDoc as getSearchChatDoc, _getUserDisplayNameByTargetAudience as getUserDisplayNameByTargetAudience, Chat_exports };